import { Error } from '../../../../../../../../../ErrorHandling';
import {
  GroupParticipantsResource,
  ParticipantResource,
} from '../../../../../../GroupParticipantsStore/Types';

export interface Ready {
  kind: 'ready';
  participant: ParticipantResource;
  groupResource: GroupParticipantsResource;
}

interface Waiting {
  kind: 'waiting';
}

interface Deleting {
  kind: 'deleting';
  participant: ParticipantResource;
  groupResource: GroupParticipantsResource;
}

interface Deleted {
  kind: 'deleted';
  participant: ParticipantResource;
}

interface Failure {
  kind: 'failure';
  participant: ParticipantResource;
  groupResource: GroupParticipantsResource;
}

export interface Success {
  kind: 'success';
  participant: ParticipantResource;
  groupResource: GroupParticipantsResource;
}

export const ready = (
  participant: ParticipantResource,
  groupResource: GroupParticipantsResource,
): Ready => ({
  kind: 'ready',
  participant,
  groupResource,
});

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const deleting = (
  participant: ParticipantResource,
  groupResource: GroupParticipantsResource,
): Deleting => ({
  kind: 'deleting',
  participant,
  groupResource,
});

export const deleted = (participant: ParticipantResource): Deleted => ({
  kind: 'deleted',
  participant,
});

export const failure = (
  participant: ParticipantResource,
  groupResource: GroupParticipantsResource,
): Failure => ({
  kind: 'failure',
  participant,
  groupResource,
});

export const success = (
  participant: ParticipantResource,
  groupResource: GroupParticipantsResource,
): Success => ({
  kind: 'success',
  participant,
  groupResource,
});

export type State = Ready | Waiting | Deleting | Failure | Success | Error | Deleted;
